<template>
  <MedalImage
    :small="small"
    :x-small="xSmall"
    :next-level="nextLevel"
    :user-level-points="userLevelPoints"
    :contribution="contribution"
    :current-level="currentLevel"
    :points-diff-next-level="pointsDiffNextLevel"
    :level-progress-percentage="levelProgressPercentage"
    :radius="radius"
    :circumference="circumference"
    :get-image-path="getImagePath"
    with-description
  />
</template>

<script setup lang="ts">
import type { UserContributionTypeEn } from "~dm-types/UserContributionTypeEn";

withDefaults(defineProps<{
  small?: boolean;
  xSmall?: boolean;
  nextLevel?: boolean;
  userLevelPoints: number;
  contribution: UserContributionTypeEn;
}>(), { nextLevel: false,small: false,xSmall: false, })

const {
  currentLevel,
  pointsDiffNextLevel,
  levelProgressPercentage,
  radius,
  circumference,
} = useMedal(__props.contribution, __props.userLevelPoints);

const { getImagePath } = images();
</script>
